import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import VoiceControls from './VoiceControls';
const MoodCheckIn = () => {
  const [selectedMood, setSelectedMood] = useState<string | null>(null);
  const [isRecording, setIsRecording] = useState(false);
  const navigate = useNavigate();
  // Simplified mood options with large emojis
  const moodOptions = [{
    emoji: '😊',
    label: 'Happy',
    color: 'bg-yellow-100'
  }, {
    emoji: '😌',
    label: 'Calm',
    color: 'bg-mint-green/50'
  }, {
    emoji: '😢',
    label: 'Sad',
    color: 'bg-blue-100'
  }, {
    emoji: '😴',
    label: 'Tired',
    color: 'bg-gray-100'
  }, {
    emoji: '😰',
    label: 'Worried',
    color: 'bg-purple-100'
  }, {
    emoji: '😡',
    label: 'Upset',
    color: 'bg-red-100'
  }];
  const handleMoodSelect = (mood: string) => {
    setSelectedMood(mood);
    // In a real app, this would save the mood and possibly show follow-up options
  };
  const handleStartRecording = () => {
    setIsRecording(true);
    // In a real app, this would activate voice recording
    setTimeout(() => {
      setIsRecording(false);
      navigate('/chat');
    }, 3000);
  };
  const handleStopRecording = () => {
    setIsRecording(false);
  };
  return <div className="space-y-8 py-4" data-id="element-224">
      <h1 className="text-3xl font-bold text-center dark:text-white" data-id="element-225">
        How are you feeling today?
      </h1>
      {/* Large emoji mood selectors */}
      <div className="grid grid-cols-2 gap-4" data-id="element-226">
        {moodOptions.map(mood => <button key={mood.label} onClick={() => handleMoodSelect(mood.label)} className={`
              p-6 rounded-3xl flex flex-col items-center justify-center transition-all
              ${selectedMood === mood.label ? `${mood.color} ring-4 ring-lavender` : `${mood.color}/50 hover:${mood.color}`}
            `} aria-label={`Feeling ${mood.label}`} data-id="element-227">
            <span className="text-6xl mb-3" data-id="element-228">{mood.emoji}</span>
            <span className="text-xl font-medium" data-id="element-229">{mood.label}</span>
          </button>)}
      </div>
      {/* Voice recording option */}
      {selectedMood && <div className="card bg-lavender/10 p-6 rounded-3xl" data-id="element-230">
          <p className="text-xl text-center mb-4 dark:text-white" data-id="element-231">
            Would you like to tell me more about how you're feeling?
          </p>
          <div className="flex justify-center" data-id="element-232">
            <button onClick={handleStartRecording} className={`
                p-6 rounded-full shadow-soft flex items-center justify-center
                ${isRecording ? 'bg-soft-coral text-white animate-pulse' : 'bg-white text-lavender'}
                transition-all hover:scale-105 active:scale-95
              `} aria-label={isRecording ? 'Stop recording' : 'Start recording'} data-id="element-233">
              <span className="text-4xl" data-id="element-234">{isRecording ? '⏹️' : '🎤'}</span>
            </button>
          </div>
          <p className="text-center mt-4 text-gray-600 dark:text-gray-300" data-id="element-235">
            {isRecording ? "I'm listening... Take your time" : 'Tap the microphone to tell me more'}
          </p>
        </div>}
      {/* Next step button */}
      <div className="flex justify-center pt-4" data-id="element-236">
        <button onClick={() => navigate('/')} className="btn btn-primary text-2xl py-5 px-10" data-id="element-237">
          Done
        </button>
      </div>
    </div>;
};
export default MoodCheckIn;